import { Suspense } from "react";

// * Third Party
import { BrowserRouter, Routes, Route } from "react-router-dom";

// * Custom Components
import AuthGuard from "./components/auth/AuthGuard";
import Loader from "./components/UI/Loader";

// * Routers
import { routers } from "./routers";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          {routers.map((route) => (
            <Route
              key={route.path}
              path={route.redirect}
              element={
                route.protected ? (
                  <AuthGuard children={<route.component />} />
                ) : (
                  <route.component />
                )
              }
            />
          ))}

          {/* <Route path="*" element={<Navigate to="/login" />} /> */}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
